export default __webpack_public_path__ + "static/artifakt-element-medium-89616650305100372ccf104033e6cc68.woff";